module.exports = __webpack_public_path__ + "img/logo.ded40602.png";